import { Component, Prop, h, State, Host } from '@stencil/core';
import '../header-component/header-component';
import '../loader-component/loader-component'

/**
#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/plainlinks-component.PNG)

#### Content Type
nypwebc_ct_plainlinks
*/


@Component({
  tag: 'plainlinks-component',
  styleUrl: 'plainlinks-component.css',
  scoped: true
})
export class PlainlinksComponent {

  /**
   *Required - Unique ID.
   */
  @Prop() componentid: string = "comp-id";

  /**
  *Required - List Name.
  */
  @Prop() listname: string = "ListName";

  /**
  *Required - Relative to the root site. no trailing slash. for ex: /hr/pm
  */
  @Prop() webpath: string = "/";

  /**
  *Required - if header attribute is true
  */
  @Prop() sectiontitle: string = "Section Title";

  /**
  *Required - if header attribute is true
  */
  @Prop() titleiconurl: string = "";

  /**
 *Optional - To show/hide header. default is true
 */
  @Prop() header: boolean = true;

  /**
 *Optional - vertical scroll bar
 */
  @Prop() verticalscroll: boolean = false;

  /**
*Optional - include icon
*/
  @Prop() includeicon: boolean = false;


  /**
 *Optional - vertical scroll bar height
 */
  @Prop() verticalscrollheight: number = 200;


  /**
  *Optional - number of items
  */
  @Prop() count: number = 100;

  /**
*Optional - header background color
*/
  @Prop() headerbgcolor: string = "white"

  /**
  *Optional -header text color
  */
  @Prop() headertextcolor: string = "black"
  /**
  *Optional -header border bottom css
  */
  @Prop() headerborderbottom: string = "1px solid #CE2127"


  /**
 *Optional - To show see All link
 */
  @Prop() seeall: boolean = false;
  /**
 *Optional - see All link
 */
  @Prop() seeallurl: string;

  /**
*Optional - is it SP Online site
*/
  @Prop() online: boolean = false;

  /**
   *Required - site url if its sp online site
   */
  @Prop() siteurl: string = "";
  /**
*Optional - see All link Title
*/
  @Prop() seealltitle: string = "See All"


  @State() items: []
  @State() isLoading: boolean = true;

  componentDidLoad() {

    // let siteUrl: string = "";

    // if (this.online) {
    //   siteUrl = this.siteurl + this.webpath
    // }
    // else {
    //   siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    // }


    let siteUrl: string = "";
    if ((window as any)._spPageContextInfo != null) {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    }
    else {
      let domain = new URL(window.location.href)
      siteUrl = domain.origin + this.webpath
    }

    // console.log(siteUrl + "-"+this.listname)


    const filter = "nypwebc_Active eq 1";
    return fetch(siteUrl + "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,nypwebc_ItemOrder,nypwebc_Url,nypwebc_ImageUrl&$filter=" + filter + "&$orderby=nypwebc_ItemOrder&$top=" + this.count, { headers: { "Accept": "application/json; odata=verbose" } })

      .then(response => response.json())
      .then(data => {
        this.items = data.d.results;
        this.isLoading = false;
      });
  }

  render() {


    let style = {}
    let styleWithHeader = {}
    let parentstyle = {}
    if (this.verticalscroll) {
      style = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }
      styleWithHeader = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }

      parentstyle = {
        minHeight: (this.verticalscrollheight + 20) + "px",
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px"
      }
    }
    else {
      style = {
      }
      parentstyle = {
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px"
      }
    }

    return (
      this.isLoading ? <loader-component />
        :
        this.header && this.items.length > 0 ?

          <div>
            <header-component sectiontitle={this.sectiontitle} titleiconurl={this.titleiconurl} seeall={this.seeall} seealltitle={this.seealltitle} seeallurl={this.seeallurl} headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} />

            <div class="row gx-0" style={parentstyle} >
              <div style={styleWithHeader} >
                <ul class="list-group list-group-flush" style={{ borderBottomRightRadius: "10px", borderBottomLeftRadius: "10px" }}>
                  {/* {this.items.map((i: any) => <li class="list-group-item"> <a href={i.nypwebc_Url} >{i.Title}</a></li>)} */}
                  {this.includeicon ? this.items.map((i: any) => <li class="list-group-item"><a href={i.nypwebc_Url}  target= "_blank" data-interception="off" > <div style={{ display: "flex" }}> <div> <img  class="img-fluid plain-icon" src={i.nypwebc_ImageUrl} /> </div> <div>{i.Title} </div> </div></a></li>) :
                    this.items.map((i: any) => <li class="list-group-item"> <a href={i.nypwebc_Url} >{i.Title}</a></li>)}
                </ul>
              </div>
            </div>
          </div>
          :
          <div class="row gx-0" style={parentstyle} >
            <div style={style} >
              <ul class="list-group list-group-flush" style={{ borderBottomRightRadius: "10px", borderBottomLeftRadius: "10px" }}>
                {this.includeicon ? this.items.map((i: any) => <li class="list-group-item"> <a href={i.nypwebc_Url} target= "_blank"  data-interception="off" > <div style={{ display: "flex" }}> <div><img class="img-fluid plain-icon"  src={i.nypwebc_ImageUrl} /> </div> <div>{i.Title}</div></div></a></li>) :
                  this.items.map((i: any) => <li class="list-group-item"> <a href={i.nypwebc_Url} >{i.Title}</a></li>)}
              </ul>
            </div>
          </div>
    )

  }
}
